import { render, staticRenderFns } from "./worker_absence_required.vue?vue&type=template&id=71ff71ac"
import script from "./worker_absence_required.vue?vue&type=script&lang=js"
export * from "./worker_absence_required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports